
// ROUTES
require('modules/notification-template/routes/notification-template');

// CONTROLLERS
require('modules/notification-template/controllers/notification-template');
require('modules/notification-template/controllers/list');
require('modules/notification-template/controllers/create');
require('modules/notification-template/controllers/edit');


// SERVICES
require('modules/notification-template/services/notification-template');
require('modules/notification-template/services/list');
require('modules/notification-template/services/create');
require('modules/notification-template/services/edit');
require('modules/notification-template/services/delete');
require('modules/notification-template/services/preview');


angular.module('unica_notification_template', [

	// ROUTES
	'unica_notification_template.notification_template_routes',

	// CONTROLLERS
	'unica_notification_template.notification_template_controllers',

	// SERVICES
	'unica_notification_template.notification_template_services'

]);